import ActionTypes from 'redux/ActionTypes';

const initialState = {
    accountId : '',
    nickname : '',
    confirmType: 'spin',
    activePage : 'livestream',
    fetchHistories: true,
	isLogin : false,
    selectedTeam: false,
    exchangeToken: 0,
    spinToken: 0,
    histories: [],
    milestones : [],
    prize : {},
}

const main = (state = initialState, { type, payload }) => {
	switch (type) {
		case ActionTypes.SET_DATA:
			return { ...state, [payload.key]: payload.data };
		default:
			return state;
	}
};

export default main;